"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfProcessingHelper = void 0;
const events_1 = require("../../../events");
class PdfProcessingHelper {
    static async processPdfUpload(file, pdfManagementService, pdfChapterService) {
        // Extract chapters from PDF
        const chaptersData = await pdfManagementService.extractChaptersFromPdf(file);
        // Select all chapters by default
        pdfChapterService.selectAllChapters(chaptersData.chapters);
        const selectedChapters = new Set(pdfChapterService.selectedChapters);
        return { chapters: chaptersData.chapters, selectedChapters, fileName: chaptersData.fileName };
    }
    static async generateTrainingDataFromPdf(selectedPdfFile, pdfContext, pdfManagementService, validationService) {
        // Generate training data from PDF
        const trainingData = await pdfManagementService.generateTrainingDataFromPdf(selectedPdfFile.path, pdfContext || undefined);
        // Validate and calculate statistics
        const validation = validationService.validateData(trainingData);
        const statistics = validationService.calculateDataStatistics(trainingData);
        return { trainingData, validation, statistics };
    }
    static async generateTrainingDataFromSelectedChapters(selectedChapters, pdfChapters, pdfContext, pdfFileName, pdfManagementService, validationService) {
        if (!pdfFileName) {
            throw new Error('PDF file path is required for generating training data');
        }
        const allTrainingData = [];
        // Generate training data for each selected chapter
        for (const chapterIndex of selectedChapters) {
            const chapter = pdfChapters[chapterIndex];
            const trainingData = await pdfManagementService.generateTrainingDataFromChapter(pdfFileName, chapter, pdfContext || undefined);
            allTrainingData.push(...trainingData);
        }
        // Validate and calculate statistics
        const validation = validationService.validateData(allTrainingData);
        const statistics = validationService.calculateDataStatistics(allTrainingData);
        return { trainingData: allTrainingData, validation, statistics };
    }
    static updateChapterSelection(operation, index, pdfChapters, pdfChapterService) {
        switch (operation) {
            case 'toggle':
                if (index !== undefined) {
                    pdfChapterService.toggleChapterSelection(index, pdfChapters);
                }
                break;
            case 'selectAll':
                pdfChapterService.selectAllChapters(pdfChapters);
                break;
            case 'deselectAll':
                pdfChapterService.deselectAllChapters();
                break;
        }
        return new Set(pdfChapterService.selectedChapters);
    }
    static emitPdfEvents(eventType, emit, data) {
        switch (eventType) {
            case 'success':
                emit(events_1.trainerEvents.uploadSuccess, { message: data.message });
                break;
            case 'error':
                emit(events_1.trainerEvents.uploadError, { error: data.error });
                break;
            case 'dataUploaded':
                emit(events_1.trainerEvents.dataUploaded, {
                    file: data.file,
                    data: data.trainingData,
                    validation: data.validation,
                    statistics: data.statistics
                });
                break;
        }
    }
    static validatePdfSelections(selectedChapters, selectedPdfFile) {
        if (selectedChapters.size === 0) {
            return 'Please select at least one chapter to generate training data';
        }
        if (!selectedPdfFile) {
            return 'No PDF file selected';
        }
        return null;
    }
}
exports.PdfProcessingHelper = PdfProcessingHelper;
